/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import ViewModel from "../../../../Basis/ViewModels/ViewModel";
import SendeSupportanfrage from "../../Commands/SendeSupportanfrage";
import KontaktformularDialogProps from "./KontaktformularDialogProps";
import KontaktformularDialogState, { createInitialState } from "./KontaktformularDialogState";

export default class KontaktformularDialogModel extends ViewModel<KontaktformularDialogState> {
    private readonly _sendeSupportanfrage: SendeSupportanfrage;

    public constructor(private readonly _props: KontaktformularDialogProps) {
        super({
            initialState: createInitialState(),
        });

        this._sendeSupportanfrage = new SendeSupportanfrage();
    }

    public get isOpen(): boolean {
        return this._props.isOpen;
    }

    public get isComplete(): boolean {
        return (this.state.betreff.trim() !== "") &&
            (this.state.text.trim() !== "");
    }

    public readonly senden = async () => {
        await this.executeCommandAsync(async () => {
            await this._sendeSupportanfrage.execute({
                betreff: this.state.betreff,
                text: this.state.text,
            });
        });

        this.hideCoffeeMug();

        this.setState(next => {
            next.betreff = "";
            next.text = "";
        });

        this._props.onGesendet();
    };

    public readonly abbrechen = () => {
        this.setState(next => {
            next.betreff = "";
            next.text = "";
        });

        this._props.onAbgebrochen();
    };
}
